<template>
    <div>
        <v-divider></v-divider>
        <v-subheader
            @click="open = !open"
        >
            <v-list-item-icon>
                <v-icon>
                    mdi-airplane
                </v-icon>
            </v-list-item-icon>
            Flights ({{outbound.length}} outbound, {{ inbound.length }} inbound)
            <v-spacer></v-spacer>
            <v-btn
                icon
            >
                <v-icon v-if="!open">
                    mdi-chevron-up
                </v-icon>
                <v-icon v-else>
                    mdi-chevron-down
                </v-icon>
            </v-btn>
        </v-subheader>
        <v-expand-transition>
            <v-list
                subheader
                v-if="open"
            >
                <v-subheader
                    inset
                >
                    Outbound
                </v-subheader>
                <v-list-item
                  three-line
                  v-for="entry in outbound"
                  :key="entry.flightNumber"
                >
                    <v-list-item-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ entry.flight.departureAirport.code }} &#8640; {{ entry.flight.arrivalAirport.code }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ new Date(entry.flight.departure).toLocaleString([], dateFormatOptions) }} &#8640; {{ new Date(entry.flight.arrival).toLocaleString([], dateFormatOptions) }}<br/>
                            {{ entry.flight.flightNumber }} ({{ entry.flight.carrier }})
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider
                    inset
                >
                </v-divider>
                <v-subheader
                    inset
                >
                    Inbound
                </v-subheader>
                <v-list-item
                  three-line
                  v-for="entry in inbound"
                  :key="entry.flightNumber"
                >
                    <v-list-item-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ entry.flight.departureAirport.code }} &#8640; {{ entry.flight.arrivalAirport.code }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ new Date(entry.flight.departure).toLocaleString([], dateFormatOptions) }} &#8640; {{ new Date(entry.flight.arrival).toLocaleString([], dateFormatOptions) }}<br/>
                            {{ entry.flight.flightNumber }} ({{ entry.flight.carrier }})
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-expand-transition>
    </div>
</template>

<script>
    export default {
        props: {
            flights: {
                type: Array,
                required: true,
            },
        },
        data: () => ({
            open: false,
            dateFormatOptions: {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute:'2-digit',
                hour12: false,
            },
        }),
        computed: {
            inbound() {
                return this.flights.filter(flight => {
                    return flight.flight.inbound;
                });
            },
            outbound() {
                return this.flights.filter(flight => {
                    return flight.flight.outbound;
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    .v-subheader {
        cursor: pointer;
        height: 56px;
    }
</style>
